<template>
    <div class="view-container">
        <div id="modals">
            <modal :showDialog="modal == 'TURN_ON'" @close="close" :title="$t('TURN_ON')">
                <question-confirm :alternative-delete-text="$t('AreYouSureTurnOnAllSystemAlarms')" :text="$t('TurnOnAlarms')" @confirm="turnAllAlarmsOnConfirmed" @cancel="close"/>
            </modal>
            <modal :showDialog="modal == 'TURN_OFF_ON_EVERYTHING'" @close="cancelFarmOff" :title="settings.areMonitoringAlarmsOff ? $t('TURN_FARM_ON') : $t('TURN_FARM_OFF')">
                <question-confirm :alternative-delete-text="settings.areMonitoringAlarmsOff ? $t('AreYouSureTurnOffFarm') : $t('AreYouSureTurnOnFarm')" :text="$t('TurnOnFarm')" @confirm="changeAlarmsOffStateConfirm" @cancel="cancelFarmOff"/>
            </modal>
            <modal :showDialog="modal == 'ADD_ALARM_RULE'" @close="close" :title="$t('ADD_ALARM_RULE')">
                <add-alarm-system-rule-modal :system-id="systemId" @save="save"/>
            </modal>
            <modal :showDialog="(modal == 'INFO_CONFIRM')" @close="close" >
                <info-confirm :text="$t('TheSettingHasBeenSaved')" @confirm="close"/>
            </modal>
        </div>
        <section id="alarms-settings">
            <h2>{{$t('Alarms')}}</h2>
            <div class="horizontal" style="margin: 15px 0;">
                <label style="margin-right: 20px;">{{ $t('TurnOffFarm') }}</label>
                <div class="horizontal" style="justify-content: center;">
                    <VueToggles @click="changeAlarmsOffState" :value="settings.areMonitoringAlarmsOff" checkedBg="#0095b2" uncheckedBg="lightgrey"></VueToggles>
                </div>
            </div>
            <div class="horizontal" style="margin: 15px 0;">
                <label style="margin-right: 20px;">{{ $t('EndDate') }}</label>
                <div class="horizontal" style="justify-content: center;">
                    <v-2-datepicker @dateChanged="changeDate" :dateFrom="settings.alarmsOffMonitoringEndDate" :timeHeader="false" :pickerType="'date'" :isDisabled="!settings.areMonitoringAlarmsOff" :min="new Date()"/>
                </div>
            </div>
            <div style="align-self: center; margin-bottom: 20px;">
                <Button :title="$t('SaveAlarms')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="saveAlarms"></Button>
            </div>
            <div style="margin: 15px 0; width: 300px">
              <label style="">{{ $t('UnknownAnimalWeightAlarmPercent') }}</label>
              <TextField style="margin-top: -15px;" v-model="unknownAnimalWeightAlarmPercent" :maxLength="2" inputClass="form-input" title=""
                valueType="number" @onChange="isUnknownAnimalWeightAlarmPercentValid" :errorMode="unknownAnimalWeightAlarmPercentError"/>
            </div>
            <div style="align-self: center; margin-bottom: 20px;">
              <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="saveUnknownAnimalWeightAlarmPercent"></Button>
            </div>
            <div style="margin: 15px 0; width: 300px">
              <label style="">{{ $t('CalibrationDateErrorAfterDays') }}</label>
              <TextField style="margin-top: -15px;" v-model="calibrationDateErrorAfterDays" :maxLength="2" inputClass="form-input" title=""
                valueType="number" @onChange="isCalibrationDateErrorAfterDaysValid" :errorMode="calibrationDateErrorAfterDaysError"/>
            </div>
            <div style="align-self: center; margin-bottom: 20px;">
              <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="saveCalibrationDateErrorAfterDays"></Button>
            </div>

            <div style="margin: 15px 0;">
                <h3>{{ $t('AlarmsTurnedOff') }}</h3>
            </div>
            <div>
                <ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="alarmsTurnedOff" :allowSorting="true" :showBusyIndicator="true">
                    <e-columns>
                        <e-column field="alarmTypeId" :headerText="$t('AlarmNumber')" textAlign="Left"></e-column>
                        <e-column field="alarmTypeName" :headerText="$t('AlarmName')" textAlign="Left"></e-column>
                        <e-column field="alarmTypePriorityName" :headerText="$t('Priority')" textAlign="Left"></e-column>
                        <e-column :headerText="$t('Options')" width="200px" :template="optionsButtons"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </section>
    </div>
</template>

<script>
import { Sort, Page, Filter, Toolbar, Search, CommandColumn } from '@syncfusion/ej2-vue-grids';
import { getAlarmSystemRules, turnOnAllAlarmsForSystem, turnOnAlarmTypeForSystem, getSystemSettingsOverview, updateSystemAlarmOff,
         getUnknownAnimalWeightAlarmParam, updateUnknownAnimalWeightAlarmParam, getCalibrationDateErrorAfterDaysParam, updateCalibrationDateErrorAfterDaysParam } from '../../api/api';

import Vue from 'vue';
import VueToggles from 'vue-toggles'
import Modal from '../../components/Modal.vue';
import AddAlarmSystemRuleModal from '../../components/Systems/AddAlarmSystemRuleModal.vue';
import QuestionConfirm from '../../components/QuestionConfirm.vue';
import InfoConfirm from '../../components/InfoConfirm.vue';
import V2Datepicker from '../../components/V2Datepicker.vue';
import Button from '../../components/Button.vue';
import TextField from '@/components/TextField'

import moment from 'moment'

var context = null;

export default {
    props: {
        systemId: {
            required: true,
            type: String
        },
        systemName: {
            required: true,
            type: String
        }
    },
    components: {
        VueToggles,
        Modal,
        AddAlarmSystemRuleModal,
        QuestionConfirm,
        InfoConfirm,
        V2Datepicker,
        Button,
        TextField
    },
    provide:
    {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn ]
    },
    data() {
        return {
            alarmsTurnedOff: [],
            settings: {
                areMonitoringAlarmsOff: false,
                alarmsOffMonitoringEndDate: null
            },
            modal: 'NONE',

            toolbar: [
                { text: this.$t('TurnOn'), id: 'turn-on-all', prefixIcon: 'e-bullet-5', align: 'Right' },
                { text: this.$t('AddRule'), id: 'add-new', prefixIcon: 'e-add', align: 'Right' },
                'Search',
            ],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            optionsButtons: function() {
                return {
                    template: Vue.component('optionsButtons', {
                        template: `
                            <div class="horizontal">
                                <button class='show-password-button' style="align-self: center;" v-on:click="onClick('turn-on')">{{ $t('TurnOn') }}</button>
                            </div>
                        `,
                        data: function () {
                            return {
                                data: {},
                            }
                        },
                        methods: {
                            onClick(mode) {
                                switch (mode) {
                                    case 'turn-on':
                                        context.turnOn(this.data)
                                        break;
                                }
                            }
                        }
                    })
                }
            },
            unknownAnimalWeightAlarmPercent: null,
            unknownAnimalWeightAlarmPercentError: "",
            calibrationDateErrorAfterDays: null,
            calibrationDateErrorAfterDaysError: ""
        }
    },
    methods: {
        getData() {
            this.getSettingsOverview();
            this.getSystemAlarmRules();
            this.getUnknownAnimalWeightAlarmPercent();
            this.getCalibrationDateErrorAfterDays();
        },
        getSettingsOverview() {
            getSystemSettingsOverview(this.systemId).then((result) => {
                this.settings = result
            })
        },
        getSystemAlarmRules() {
            getAlarmSystemRules(this.systemId).then((response) => {
                response.forEach(el => {
                    el.alarmTypePriorityName = [this.$t('HIGH'), this.$t('MID'), this.$t('LOW')][el.alarmPriority - 1]
                })

                this.alarmsTurnedOff = response
            })
        },
        getUnknownAnimalWeightAlarmPercent() {
          getUnknownAnimalWeightAlarmParam(this.systemId).then((response) => {
            this.unknownAnimalWeightAlarmPercent = response
          })
        },
        getCalibrationDateErrorAfterDays() {
          getCalibrationDateErrorAfterDaysParam(this.systemId).then((response) => {
            this.calibrationDateErrorAfterDays = response
          })
        },
        isCalibrationDateErrorAfterDaysValid(value) {
          if (isNaN(value) || value == null || value == undefined || value.length === 0) {
            this.calibrationDateErrorAfterDaysError = 'Required'
          } else {
            this.calibrationDateErrorAfterDays = value
            this.calibrationDateErrorAfterDaysError =""
          }
        },
        isUnknownAnimalWeightAlarmPercentValid(value) {
          if (isNaN(value) || value == null || value == undefined || value.length === 0) {
            this.unknownAnimalWeightAlarmPercentError = 'Required'
          } else {
            this.unknownAnimalWeightAlarmPercent = value
            this.unknownAnimalWeightAlarmPercentError =""
          }
        },
        changeAlarmsOffState() {
            this.settings.areMonitoringAlarmsOff = !this.settings.areMonitoringAlarmsOff
        },
        changeAlarmsOffStateConfirm() {
            this.modal = 'NONE'

            var objectToSend = {
                IsOff: this.settings.areMonitoringAlarmsOff,
                EndDate: this.settings.alarmsOffMonitoringEndDate != null ? moment(this.settings.alarmsOffMonitoringEndDate).format('YYYY-MM-DDTHH:mm:ss+00:00') : null
            }

            updateSystemAlarmOff(this.systemId, objectToSend).then(_ => this.getSettingsOverview())
        },
        turnAllAlarmsOn() {
            this.modal = 'TURN_ON'
        },
        turnAllAlarmsOnConfirmed() {
            this.modal = 'NONE'
            turnOnAllAlarmsForSystem(this.systemId).then((_) => {
                this.getSystemAlarmRules()
            })
        },
        changeDate(value) {
            this.settings.alarmsOffMonitoringEndDate = value
        },
        toolbarClick(args) {
            switch(args.item.id){
                case "turn-on-all":
                    this.turnAllAlarmsOn();
                    break;
                case 'add-new':
                    this.addNewRule();
                    break;
            }
        },
        addNewRule(){
            this.modal = 'ADD_ALARM_RULE';
        },
        dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        turnOn(data) {
            var toSend = [ data.id ];
            turnOnAlarmTypeForSystem(toSend).then(_ => {
                this.getSystemAlarmRules()
            })
        },
        close() {
            this.modal = 'NONE';
        },
        save() {
            this.close();
            this.getSystemAlarmRules();
        },
        cancelFarmOff() {
            this.settings.areMonitoringAlarmsOff = !this.settings.areMonitoringAlarmsOff
            this.close()
        },
        saveAlarms() {
            this.modal = 'TURN_OFF_ON_EVERYTHING'
        },
        saveUnknownAnimalWeightAlarmPercent() {
          this.isUnknownAnimalWeightAlarmPercentValid(this.unknownAnimalWeightAlarmPercent);

          if (this.unknownAnimalWeightAlarmPercentError == "") {
            updateUnknownAnimalWeightAlarmParam(this.systemId, this.unknownAnimalWeightAlarmPercent).then(() => {
              this.modal = 'INFO_CONFIRM'
            })
          }
        },
        saveCalibrationDateErrorAfterDays() {
          this.isCalibrationDateErrorAfterDaysValid(this.calibrationDateErrorAfterDays);

          if (this.calibrationDateErrorAfterDaysError == "") {
            updateCalibrationDateErrorAfterDaysParam(this.systemId, this.calibrationDateErrorAfterDays).then(() => {
              this.modal = 'INFO_CONFIRM'
            })
          }
        }
    },
    mounted() {
        context = this;
        this.getData();
    }
}
</script>

<style scoped>
.section-header {
    font-weight: bold;
    font-size: 25px;
}
</style>

<style>
.show-password-button {
    border: 1px #ddd solid;
    padding: 5px 10px;
    background: none;
}

.show-password-button:hover {
    background: #bbbbbb;
}
</style>



// WEBPACK FOOTER //
// src/views/System/SystemSettings.vue